export const SDK_VERSION = '7.69.0';
